export const environment = {
    production: true,    
    apiUrl: 'https://dagpacket-backend.onrender.com/api/v1',
    googleApi: 'AIzaSyAauNhkAgl2vnaD4U4xojIC_RFE9lkUmoA'
  };
  //https://dagpacket-backend.onrender.com/api/v1
  //https://dagpacket-backend.onrender.com